<div class="px-3 mt-2">

    Draw an area on the map to start.

    <div class="d-flex justify-content-center pb-3 btn-clear-wrapper mt-3">
        <button type="button" class="btn btn-primary btn-clear-map btn-sm" (click)="mapClear()"><i
                class="far fa-eraser"></i>
            Clear</button>
    </div>

</div>